'use strict';
var base = require('./base');
const baseDetail = require('base/product/detail');
const baseDetailExt = $.extend({}, baseDetail);
var deliverySelector = require('./deliverySelector');


function updateAttributesAndDetails() {
    $('body').on('product:statusUpdate', function (e, data) {
        var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

        $productContainer.find('.description-and-detail .product-attributes')
            .empty()
            .html(data.attributesHtml);

        if (data.shortDescription) {
            $productContainer.find('.description-and-detail .description')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .description .content')
                .empty()
                .html(data.shortDescription);
        } else {
            $productContainer.find('.description-and-detail .description')
                .addClass('hidden-xl-down');
        }

        if (data.longDescription) {
            $productContainer.find('.description-and-detail .details')
                .removeClass('hidden-xl-down');
            $productContainer.find('.description-and-detail .details .content')
                .empty()
                .html(data.longDescription);
        } else {
            $productContainer.find('.description-and-detail .details')
                .addClass('hidden-xl-down');
        }
    });
}

module.exports = {
    updateAttributesAndDetails: updateAttributesAndDetails,
    deliverySelector: deliverySelector.init(),
    showSpinner: baseDetailExt.showSpinner(),
    updateAttribute: baseDetailExt.updateAttribute(),
    updateAddToCart: baseDetailExt.updateAddToCart(),
    updateAvailability: baseDetailExt.updateAvailability(),
    sizeChart: baseDetailExt.sizeChart(),
    copyProductLink: baseDetailExt.copyProductLink(),
    focusChooseBonusProductModal: base.focusChooseBonusProductModal()
};
